// src/pages/TrackCreation/TitleScreen.tsx
import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { TitleScreenProps } from "../../../../types/screensTypes";
import { useTrackCreation } from "../../../../context/TrackCreationContext";
import TitleSubtitle from "../../../../components/common/TitleSubtitle";
import TextInput from "../../../../components/ui/TextInput";
import Button from "../../../../components/ui/Button";
import stepStyles from "../createStep.module.css";

const TitleScreen: React.FC<TitleScreenProps> = ({ navigateToNext }) => {
    const { trackData, updateTrackData } = useTrackCreation();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        updateTrackData("title", e.target.value);
    };

    return (
        <div className={`step-container ${stepStyles.stepContainer} ${stepStyles.step} ${stepStyles.stepTitle}`}>
            <TitleSubtitle
                title={t("whatIsTheCustomerFacingTitleOfYourAudioTour")}
                subtitle={""}
                tooltip={t("doNotTranslateTooltip")}
                layout="titleField"
            />

            <div className={stepStyles.stepDescription}>
                <TextInput
                    placeholder={t("pleaseInsertYourText")}
                    value={trackData.title ? trackData.title : ""}
                    onChange={(e) => handleChange(e)}
                    size="medium"
                />
            </div>

            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    label={t("continue")}
                    onClick={navigateToNext}
                    disabled={!trackData.title}
                    variant="primary"
                    shape="pill"
                    className={stepStyles.continueBtn}
                />
            </div>
        </div>
    );
};

export default TitleScreen;
